import { createSlice } from '@reduxjs/toolkit';
import { configurationAction } from '../actions';
import { configurationReducer as extraReducers } from '../reducers';
import { IConfigurationState, ISalesForceData } from '../../interfaces';

const initialState: IConfigurationState = {
  status: 'inactive',
  whatsappLink: '',
  cookieNameAuth: null,
  merchantList: [],
  paymentMethods: [],
  typesOperatingSystem: [],
  salesForceData: {} as ISalesForceData,
  error: '',
};

export const configurationSlice = createSlice({
  name: 'configuration',
  initialState,
  // Non-async reducers
  reducers: {
    resetConfiguration: () => {
      return initialState;
    },
  },
  // Async reducers
  extraReducers,
});

// Action creators are generated for each case reducer function
export const configurationSliceActions = { ...configurationSlice.actions, ...configurationAction };

export default configurationSlice.reducer;
